export const DIGIT_HEIGHT = 16; // should be the same of text "lineHeight" and should be a rounded number to avoid javascript calc errors
